export default "__VITE_ASSET__pl8_fTwB__"